import { JSX } from "react";
import { Navigate } from "react-router-dom";

interface Props {
  children: JSX.Element;
}

export default function PublicRoute({ children }: Props) {
  const token = localStorage.getItem("token");

  // If already logged in, redirect away from login/reset-password
  if (token) {
    return <Navigate to="/" replace />;
  }

  return children;
}
